import {lazy, memo, Suspense} from 'react';
import {Box, CircularProgress, Popover, Typography} from '@mui/material';

// Lazy load the EmojiPicker component
const EmojiPicker = lazy(() => import('emoji-picker-react'));

const EmojiPickerDialog = memo(({ anchorEl, onClose, onEmojiSelect }) => {
  const open = Boolean(anchorEl);

  const handleEmojiSelect = (emojiObject) => {
    onEmojiSelect(emojiObject);
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      PaperProps={{
        className: 'dialog-glass',
        sx: {
          overflow: 'hidden'
        }
      }}
    >
      <Box sx={{ 
        p: 0, 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 2,
        width: 360,
        height: 480
      }}>
        <Typography variant="h6" className="gradient-text" sx={{ p: 2, pb: 0 }}>
          Emoji auswählen
        </Typography>
        
        <Suspense fallback={
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            height: '400px' 
          }}>
            <CircularProgress />
          </Box>
        }>
          <Box className="emoji-picker-container">
            <EmojiPicker
              onEmojiClick={handleEmojiSelect}
              autoFocusSearch={false}
              searchPlaceholder="Emoji suchen..."
              width="100%"
              height={400}
              theme="dark"
              lazyLoadEmojis={true}
              previewConfig={{
                showPreview: false
              }}
              searchDisabled={false}
              skinTonesDisabled={true}
              emojiStyle="native"
              emojiVersion="14"
              categories={{
                frequent: "Häufig verwendet",
                people: "Smileys & Personen",
                nature: "Tiere & Natur",
                food: "Essen & Trinken",
                activities: "Aktivitäten",
                travel: "Reisen & Orte",
                objects: "Objekte",
                symbols: "Symbole",
                flags: "Flaggen"
              }}
            />
          </Box>
        </Suspense>
      </Box>
    </Popover>
  );
});

EmojiPickerDialog.displayName = 'EmojiPickerDialog';

export default EmojiPickerDialog; 